import addCountry from './add-country';
import addProduct from './add-product';
import changeBudgetDeprecated from './change-budget-deprecated';
import {
  EndCampaign,
  PauseCampaign,
  UnpauseCampaign,
} from './change-campaign-status';
import changeMerchantExclusivity from './change-merchant-exclusivity';
import changeProductBudget from './change-product-budget';
import changeRuntime from './change-runtime';
import changeTarget from './change-target';
import moveBudgetToWallet from './move-budget-to-wallet';
import refreshSKU from './refresh-sku';
import transferBudget from './transfer-budget/transfer-budget';

export default [
  addCountry,
  addProduct,
  changeBudgetDeprecated,
  changeMerchantExclusivity,
  changeProductBudget,
  transferBudget,
  changeRuntime,
  changeTarget,
  EndCampaign,
  moveBudgetToWallet,
  PauseCampaign,
  refreshSKU,
  UnpauseCampaign,
];
